import { Loader2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { STATUS_COLORS } from '../../data/landingData';

export default function LeadsTab({ leads, loading, onUpdateStatus }) {
  return (
    <div className="border border-gray-200 bg-white" data-testid="leads-table">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="font-['Chivo'] font-bold text-lg text-[#111827]">Leads entrants</h2>
        <p className="text-sm text-gray-500 font-['IBM_Plex_Sans']">{leads.length} lead(s) au total</p>
      </div>
      {loading && (
        <div className="p-8 text-center"><Loader2 className="animate-spin mx-auto text-[#E3000F]" size={24} /></div>
      )}
      {!loading && leads.length === 0 && (
        <div className="p-8 text-center text-gray-500 font-['IBM_Plex_Sans']">Aucun lead pour le moment</div>
      )}
      {!loading && leads.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-[#F9FAFB] border-b border-gray-200">
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Contact</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Téléphone</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Ville</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Type</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Date</th>
                <th className="text-left px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500 font-['IBM_Plex_Sans']">Statut</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} className="border-b border-gray-100 hover:bg-[#F9FAFB]" data-testid={`lead-row-${lead.id}`}>
                  <td className="px-4 py-3">
                    <p className="text-sm font-semibold text-[#111827]">{lead.first_name} {lead.last_name}</p>
                    <p className="text-xs text-gray-500">{lead.email}</p>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700">{lead.phone}</td>
                  <td className="px-4 py-3 text-sm text-gray-700">{lead.city}</td>
                  <td className="px-4 py-3 text-sm text-gray-700">{lead.declaration_type}</td>
                  <td className="px-4 py-3 text-xs text-gray-500">
                    {lead.created_at ? new Date(lead.created_at).toLocaleDateString('fr-CH') : '—'}
                  </td>
                  <td className="px-4 py-3">
                    <Select value={lead.status || 'new'} onValueChange={(v) => onUpdateStatus(lead.id, v)}>
                      <SelectTrigger className={`rounded-none text-xs font-semibold border-0 h-7 px-2 ${STATUS_COLORS[lead.status || 'new']}`} data-testid={`lead-status-${lead.id}`}>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="new">Nouveau</SelectItem>
                        <SelectItem value="contacted">Contacté</SelectItem>
                        <SelectItem value="converted">Converti</SelectItem>
                        <SelectItem value="lost">Perdu</SelectItem>
                      </SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
